export const CRM_WEBHOOK_URL = "https://api.neuravolt.in/leads/capture";
export const CRM_API_KEY = "nv_lead_live_f8b7e8994670d1513feeb751a09fe2fc";

/**
 * Direct webhook integration to capture leads into In-House CRM.
 * Guaranteed non-blocking: wrapped in try/catch so form submission flow
 * always succeeds without disruption.
 */
export async function captureCrmLead({
  name = "",
  email = "",
  phone = "",
  service = "",
  website = "",
  notes = "",
  company = "",
  budget = "",
  role = "",
  portfolio_url = "",
  resume_url = "",
} = {}) {
  try {
    const notesList = [];
    if (company) notesList.push(`Company: ${company}`);
    if (budget) notesList.push(`Budget: ${budget}`);
    if (role) notesList.push(`Role applied: ${role}`);
    if (portfolio_url) notesList.push(`Portfolio: ${portfolio_url}`);
    if (resume_url) notesList.push(`Resume: ${resume_url}`);
    if (notes) notesList.push(notes);

    const siteDomain =
      website ||
      (typeof window !== "undefined" && window.location?.hostname
        ? window.location.hostname
        : "neuravolt.in");

    const payload = {
      name: (name || "Prospective Client").trim(),
      email: (email || "").trim(),
      phone: (phone || "").trim(),
      service: (service || "General Inquiry").trim(),
      website: siteDomain,
      notes: notesList.join("\n") || "Inquiry details from website contact form...",
    };

    const response = await fetch(CRM_WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": CRM_API_KEY,
      },
      body: JSON.stringify(payload),
    });

    return response;
  } catch (error) {
    console.warn("Direct CRM lead capture webhook notification:", error);
    return null;
  }
}
